import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-of-service-layout',
  templateUrl: './terms-of-service-layout.component.html',
  styleUrls: ['./terms-of-service-layout.component.css']
})
export class TermsOfServiceLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
